var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 610,
    viewBox: "0 0 700 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M700 503.358L683.065 503.358L683.065 571.733L659.971 596.153L599.928 596.153L599.928 599.408L649.194 599.408L649.194 609.176L661.511 609.176L700 573.361L700 503.358Z",
    fill: "#F70FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 105.818H16.9353L16.9353 37.4434L40.0288 13.0238L100.072 13.0238L100.072 9.76781L50.8058 9.76781L50.8058 -3.8147e-05H38.4893L2.05124e-06 35.8154L0 105.818Z",
    fill: "#12D6DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_86_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M662.358 596.751L685.99 572.173L685.99 468.047L674.977 458.817L674.977 376.343L685.99 366.22L685.99 281.96L674.977 271.837L674.977 187.278L685.99 177.155L685.99 24.1168L481.148 24.1168L465.19 12.1834L97.4685 12.1836L39.8735 12.184L15.5073 35.4434L15.5075 177.155L25.9034 187.576L25.9034 271.837L15.5075 281.96L15.5075 366.22L25.9034 377.237L25.9033 457.627L15.5073 468.047L15.5073 604.944L280.602 604.944L288.479 596.752L323.14 596.752L662.358 596.751Z",
    fill: "url(#paint0_linear_86_43)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.939 596.232C288.08 596.085 288.275 596.002 288.479 596.002L323.14 596.002L662.039 596.001L685.24 571.871L685.24 468.397L674.495 459.392C674.325 459.25 674.227 459.039 674.227 458.817L674.227 376.343C674.227 376.134 674.315 375.933 674.469 375.791L685.24 365.891L685.24 282.289L674.469 272.389C674.315 272.247 674.227 272.047 674.227 271.837L674.227 187.278C674.227 187.069 674.315 186.868 674.469 186.726L685.24 176.826L685.24 24.8668L481.148 24.8668C480.986 24.8668 480.829 24.8144 480.699 24.7174L464.94 12.9334L97.4685 12.9336L40.1741 12.9339L16.2573 35.7643L16.2575 176.845L26.4343 187.046C26.5746 187.187 26.6534 187.378 26.6534 187.576L26.6534 271.837C26.6534 272.039 26.5716 272.233 26.4266 272.374L16.2575 282.276L16.2575 365.922L26.4489 376.722C26.5802 376.861 26.6534 377.045 26.6534 377.237L26.6533 457.627C26.6533 457.825 26.5745 458.016 26.4343 458.156L16.2573 468.358L16.2573 604.194L280.283 604.194L287.939 596.232Z",
    stroke: "url(#paint1_linear_86_43)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_86_43",
    x: -4.49268,
    y: -7.81665,
    width: 710.483,
    height: 632.761,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_86_43"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_86_43",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_86_43",
    x1: 688.565,
    y1: 184.275,
    x2: 64.8805,
    y2: 189.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#330C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F2A58"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_86_43",
    x1: 688.565,
    y1: 222.518,
    x2: 64.8891,
    y2: 228.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F70FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12D6DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalBg);
export default __webpack_public_path__ + "static/media/modal_bg.3f1728b5fdca64ea1fca35016737b077.svg";
export { ForwardRef as ReactComponent };